import React, { useState, useEffect } from "react";
import {
  Typography,
  Input,
  Modal,
  Button,
  Select,
  Form,
  Col,
  Row,
  DatePicker,
  Checkbox,
  Tag,
  Icon,
  message,
  Tabs,
  Table,
} from "antd";
import moment from "moment";
import AddReceipt from "./AddReceipt";
import { platformApi } from "../../../../../api";

const { Title, Text } = Typography;
const { Option } = Select;
const { Item } = Form;
const { TabPane } = Tabs;

const OrderManagementForm = ({ selectedData, open, close, editable, form }) => {
  const { getFieldDecorator, setFieldsValue } = form;
  const [receiptModalVisible, setReceiptModalVisible] = useState(false);
  const [loading, setLoading] = useState(false);
  const [isEditable, setIsEditable] = useState(editable);

  useEffect(() => {
    setIsEditable(editable);
  }, [editable]);

  const receiptDisabled =
    !isEditable ||
    selectedData.status == "PENDING" ||
    selectedData.status == "RECEIVED";
  const imyDisabled =
    !isEditable ||
    selectedData.status == "PARTIALLY_RECEIVED" ||
    selectedData.status == "RECEIVED";
  selectedData.status == "COMPLETED";

  console.log("imydisable?", imyDisabled);

  useEffect(() => {
    if (selectedData) {
      setFieldsValue({
        iymOrderNo: selectedData.iymOrderNo,
        iymOrderDate: selectedData.iymOrderDate
          ? moment(selectedData.iymOrderDate)
          : null,
      });
    }
  }, [selectedData]);

  const handleSave = () => {
    form.validateFields((err, values) => {
      if (!err) {
        const data = {
          iymOrderNo: values.iymOrderNo,
          iymOrderDate: values.iymOrderDate.format("YYYY-MM-DD"),
        };
        platformApi
          .post(
            `/api/customerSpareOrderRouter/updateIYMDetails/${selectedData.id}`,
            data
          )
          .then(() => {
            message.success("Order details updated successfully");
            close();
          })
          .catch((error) => {
            console.error(error);
            message.error("Failed to update order details");
          });
      }
    });
  };

  const handleDeleteReceipt = async (receiptId) => {
    try {
      await platformApi.delete(
        `/api/customerSpareOrderRouter/spare-orders/${selectedData.id}/receipts/${receiptId}`
      );
      message.success("Receipt deleted successfully");
      // Refresh the parent component to get updated receipts
      close();
    } catch (error) {
      console.error(error);
      const errMsg = error.response?.data?.message || "Failed to delete receipt";
      message.error(errMsg);
    }
  };

  const receiptColumns = [
    {
      title: "Receive Date",
      dataIndex: "receiveDate",
      key: "receiveDate",
      render: (text) => (text ? moment(text).format("DD-MM-YYYY") : "-"),
    },
    {
      title: "Part Number",
      dataIndex: "receivedPartNo",
      key: "receivedPartNo",
      render: (_, record) => (
        <span>
          {record?.receivedPartNo?.partNumber ||
            (typeof record?.receivedPartNo === "string" ? record.receivedPartNo : null) ||
            selectedData?.orderedPartNo?.partNumber ||
            selectedData?.orderedPartNo ||
            "-"}
        </span>
      ),
    },
    {
      title: "Part Name",
      dataIndex: "receivedPartName",
      key: "receivedPartName",
      render: (_, record) => (
        <span>
          {record?.receivedPartNo?.partName ||
            record?.receivedPartName ||
            selectedData?.orderedPartNo?.partName ||
            selectedData?.orderedPartName ||
            "-"}
        </span>
      ),
    },
    {
      title: "Quantity",
      dataIndex: "receivedQuantity",
      key: "receivedQuantity",
    },
    {
      title: "Bill No",
      dataIndex: "billNo",
      key: "billNo",
    },
    {
      title: "Supplier",
      dataIndex: "supplier",
      key: "supplierId",
      render: (_, record) => (
        <span>
          {record?.supplier?.name ||
            (typeof record?.supplier === "string" ? record.supplier : null) ||
            (record?.billNo?.startsWith("TRF") ? "Transfer Inward" : "-")}
        </span>
      ),
    },
    {
      title: "Action",
      key: "action",
      render: (_, record) => (
        <span
          onClick={(event) => {
            event.stopPropagation();
            handleDeleteReceipt(record.id);
          }}
          className="linkylink"
        >
          Delete
        </span>
      ),
    },
  ];

  return (
    <>
      <Modal
        wrapClassName="vehicle-form"
        visible={open}
        title={<Title level={4}>Order Management</Title>}
        onCancel={close}
        okText={isEditable ? "Save" : "Modify"}
        onOk={isEditable ? handleSave : () => setIsEditable(true)}
        width={800}
      >
        <Form layout="vertical">
          <h3>Part Details</h3>
          <Row gutter={16}>
            <Col span={12}>
              <Item label="Part Number">
                <Input value={selectedData?.orderedPartNo?.partNumber || selectedData?.orderedPartNo || ""} disabled />
              </Item>
            </Col>
            <Col span={12}>
              <Item label="Customer Name">
                <Input
                  value={selectedData?.customerSpareOrder?.partyName?.name || selectedData?.saleSpareInvoice?.partyName?.name || "-"}
                  disabled
                />
              </Item>
            </Col>
          </Row>
          <Row gutter={16}>
            <Col span={12}>
              <Item label="Part Name">
                <Input value={selectedData?.orderedPartNo?.partName || selectedData?.orderedPartName || ""} disabled />
              </Item>
            </Col>
            <Col span={12}>
              <Item label="Ordered Quantity">
                <Input value={selectedData?.orderedQuantity || 0} disabled />
              </Item>
            </Col>
          </Row>

          <h3 style={{ marginTop: "20px" }}>Order Details</h3>
          <Row gutter={16}>
            <Col span={12}>
              <Item label="IYM Order No" required>
                {getFieldDecorator("iymOrderNo", {
                  rules: [
                    { required: true, message: "Please input IYM Order No!" },
                  ],
                  initialValue: selectedData.iymOrderNo,
                })(<Input disabled={imyDisabled} />)}
              </Item>
            </Col>
            <Col span={12}>
              <Item label="IYM Order Date" required>
                {getFieldDecorator("iymOrderDate", {
                  rules: [
                    { required: true, message: "Please input IYM Order Date!" },
                  ],
                  initialValue: selectedData.iymOrderDate
                    ? moment(selectedData.iymOrderDate)
                    : null,
                })(
                  <DatePicker
                    style={{ width: "100%" }}
                    disabled={imyDisabled}
                  />
                )}
              </Item>
            </Col>
          </Row>

          <h3 style={{ marginTop: "20px" }}>Receipt Details</h3>
          <Button
            type="primary"
            onClick={() => setReceiptModalVisible(true)}
            disabled={receiptDisabled}
            style={{ marginBottom: 16 }}
          >
            Add Receipt
          </Button>
          <Table
            columns={receiptColumns}
            dataSource={selectedData.receipts || []}
            rowKey="id"
            pagination={false}
          />
        </Form>
      </Modal>

      <AddReceipt
        visible={receiptModalVisible}
        onCancel={() => setReceiptModalVisible(false)}
        orderId={selectedData.id}
        onSuccess={() => {
          setReceiptModalVisible(false);
          close();
        }}
        selectedData={selectedData}
      />
    </>
  );
};

export default Form.create()(OrderManagementForm);
